import {useAxios} from "hooks/useAxios";
import {useMutation, useQueryClient} from "react-query";
import {notificationsKeys} from "./keys";

const ENDPOINT = "/v1/notifications";

const useNotificationsSeenUpdateMutation = () => {
  const queryClient = useQueryClient();
  const { axios } = useAxios();

  return useMutation(
    (notificationId) => {
      return axios.patch(`${ENDPOINT}/${notificationId}`);
    },
    {
      onSuccess: () => {
        queryClient.refetchQueries(notificationsKeys.default);
      },
    }
  );
};

export default useNotificationsSeenUpdateMutation;
